import * as React from 'react';
import { IconChevronSmallDown } from '@tock/icons';
// eslint-disable-next-line no-restricted-imports
import { Select as MuiSelect } from '@material-ui/core';
import { SelectProps as MuiSelectProps } from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import { useSelectStyles } from './selectStyles';
import clsx from 'clsx';

export interface SelectProps extends MuiSelectProps {
  label?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingRight: theme.spacing(4),
  },
  paddingWithLabel: {
    padding: `${theme.typography.pxToRem(18.5)} ${theme.typography.pxToRem(
      12
    )} ${theme.typography.pxToRem(8.5)}`,
  },
  paddingWithoutLabel: {
    padding: `${theme.typography.pxToRem(13)} ${theme.typography.pxToRem(14)}`,
  },
}));

const Select: React.FunctionComponent<SelectProps> = ({
  children,
  id,
  inputProps,
  label,
  labelWidth,
  name,
  native,
  ...rest
}) => {
  const selectClasses = useSelectStyles({ label });
  const classes = useStyles();

  return (
    <MuiSelect
      inputProps={{
        name,
        id,
        className: clsx(
          { [classes.paddingWithLabel]: !!label, [classes.paddingWithoutLabel]: !label },
          classes.root
        ),
        ...inputProps,
      }}
      classes={selectClasses}
      native={native}
      IconComponent={IconChevronSmallDown}
      variant="filled"
      {...rest}
    >
      {children}
    </MuiSelect>
  );
};

export default Select;
